import React from 'react';
import FAQ from './faq';
import { forsideFAQData } from '../data/faqData';

const ForsideFAQ = () => {
  return (
    <FAQ 
      faqData={forsideFAQData}
      title="Ofte stillede spørgsmål"
      subtitle="Find hurtigt svar på de mest almindelige spørgsmål om vores tjenester og proces. Har du andre spørgsmål? Kontakt os direkte."
      className="faq-forside"
      showCTA={true}
    />
  );
};

export default ForsideFAQ;
